import { waterfallSaleAssets } from "assets/cdn";
import Button from "components/Buttons/ThemeButton";
import {
	Container,
	Description,
	DescriptionContainer,
	ItemImage,
	Items,
	LockIcon,
	LoyalBox,
	LoyalBoxWrap,
	Percentage,
	RewardAmount,
	RewardItem
} from "./styles";
import { CrownIcon, CrownIconV2 } from "utils/svgIcons";
import {
	useEnvContext,
	useGoogleAnalyticsContext,
	useWebStoreContext
} from "contexts";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { WsDialogs } from "interfaces";
import "animate.css";
import useRewardsById from "hooks/useRewardsById";
import { selectPoisBountyV3State } from "redux/slices";
import { useAppSelector } from "hooks";
// import { CardFinalMessage } from "styles/general_styles";
import { LoyaltyPointsV2 } from "styles/general_styles";
import { FeaturesFlags } from "helpers";
import { sortBundleRewards } from "helpers/rewardSort";
import { useImagePath } from "hooks/useImagePath";
import { useMediaQuery } from "@mui/material";

export interface ITierStatus {
	index: number;
	completed: boolean;
	tier: {
		rewardId: string;
		imageUrl: string;
		title: string;
		offerId: string;
	};
}

export interface IOffer {
	rewardId: string;
	id: string;
	price: number;
	loyaltyPointReward: Date;
}
interface Props {
	saleId: string;
	tierStatuses: ITierStatus[];
	tierStatus: ITierStatus;
	offer: {
		rewardId: string;
		id: string;
		price: number;
		loyaltyPointReward: Date;
	};
	inputMockChecked?: boolean;
}

export const WaterFallCard: React.FC<Props> = ({
	saleId,
	tierStatuses,
	tierStatus,
	offer
}) => {
	const { wsStoreBuy, authToken, suppressOrderConfirmation, postUserMetadata } =
		useWebStoreContext();
	const { getImage } = useImagePath("cdn");
	const checkIcon = getImage(waterfallSaleAssets.checkIcon);
	const chain = getImage(waterfallSaleAssets.chain);
	const { canContribute: isPoisActive } = useAppSelector(
		selectPoisBountyV3State
	);

	const isPortrait = useMediaQuery("(max-width:733px)");
	const { reportEvent } = useGoogleAnalyticsContext();
	const { isFeatureFlagEnabled } = useEnvContext();
	const { openDialog } = useDialogModalRedux();
	const displayRewards = useRewardsById(
		offer?.rewardId || tierStatus?.tier?.rewardId
	);

	const isPreviousTierCompleted = (reverseValue = 1) => {
		return tierStatuses[tierStatus?.index - reverseValue]
			? tierStatuses[tierStatus?.index - reverseValue]?.completed
			: true;
	};

	const separateString = (cadena: string) => {
		const percentage = cadena.replace(/[a-zA-Z!]/g, "");
		const description = cadena.replace(/[0-9%]/g, "");
		return {
			percentage,
			description
		};
	};

	const onClickBuy = async () => {
		if (!authToken?.value) {
			return;
		}
		const invoice = await wsStoreBuy({
			offerId: offer.id,
			waterfallSaleId: saleId,
			waterfallSaleTierIndex: tierStatus?.index
		});

		if (invoice) {
			openDialog(WsDialogs.XSOLLA_PURCHASE, {
				xsollaToken: invoice.xsollaToken,
				xsollaHost: invoice.xsollaHost,
				section: "shop",
				source: "waterfall",
				suppressOrderConfirmation,
				postUserMetadata,

				onPurchaseStarted: (data) => {
					reportEvent("purchase_started", {
						section_name: "limited_deals",
						offer_id: `${saleId}-${tierStatus?.index}`,
						price_in_cents: offer?.price * 100,
						reward_id: "123",
						invoice_id: invoice?.id,
						paystation_id: data?.payStation
					});
				},
				onPurchaseSuccess: () => {
					reportEvent("purchase_success", {
						invoice_id: invoice?.id
					});
				}
			});
		}
	};

	const formatedTitle = separateString(tierStatus?.tier?.title);

	return (
		<Container image={tierStatus?.tier?.imageUrl}>
			<DescriptionContainer>
				{tierStatus.index === 0 ? (
					<Description>{tierStatus?.tier?.title}</Description>
				) : (
					<>
						<Percentage>
							{!tierStatus?.tier?.rewardId && formatedTitle.percentage}
						</Percentage>
						<Description
							variant={tierStatus?.tier?.rewardId ? "freeItem" : "item"}
						>
							{formatedTitle.description}
						</Description>
					</>
				)}
			</DescriptionContainer>
			{tierStatus?.completed ? (
				<Items isOffer={false}>
					<img
						className="animate__animated animate__rubberBand"
						src={checkIcon}
						width={isPortrait ? "55%" : "80%"}
					/>
				</Items>
			) : (
				<>
					<Items isOffer={tierStatus?.tier?.rewardId ? false : true}>
						{sortBundleRewards(displayRewards).map((displayReward) => (
							<RewardItem
								key={displayReward.id}
								width={"50%"}
								filter={
									isPreviousTierCompleted() ||
									(isPreviousTierCompleted(2) && tierStatus?.tier?.rewardId)
										? 0
										: 100 //Disabled
								}
							>
								<ItemImage
									className="item-icon"
									src={displayReward.imageUrl}
									alt=""
									loyaltyBoxExtraMessage={isPoisActive}
								/>
								<RewardAmount className="description">
									{displayReward.description}
								</RewardAmount>
							</RewardItem>
						))}
					</Items>
					{offer && (
						<>
							{isFeatureFlagEnabled(FeaturesFlags.UI_V2) ? (
								<LoyalBoxWrap loyaltyBoxExtraMessage={isPoisActive}>
									<LoyaltyPointsV2
										position="absolute"
										fontSize="1.2em"
										padding="0.33em 0.5em"
									>
										<div>
											Earn
											<CrownIconV2 width="1em" height="auto" />
											{offer?.loyaltyPointReward?.toLocaleString("en-US")}
										</div>
										{/*
											{isPoisActive && (
												<CardFinalMessage
													color="#FBBD05"
													fontSize={isPortrait ? "0.53em" : "0.85em"}
												>
													Contribute to Poi’s Bounty
												</CardFinalMessage>
											)}
										*/}
									</LoyaltyPointsV2>
								</LoyalBoxWrap>
							) : (
								<LoyalBoxWrap loyaltyBoxExtraMessage={isPoisActive}>
									<LoyalBox
										loyaltyBoxExtraMessage={isPoisActive}
										sx={{
											fontSize: isPoisActive
												? isPortrait
													? "0.71em"
													: "1.02em"
												: isPortrait
												? "0.94em"
												: "1.47em"
										}}
									>
										<div>
											Earn
											<CrownIcon width="1em" />
											{` ${offer?.loyaltyPointReward.toLocaleString("en-US")}`}
										</div>
										{/*
											{isPoisActive && (
												<CardFinalMessage
													color="#FBBD05"
													fontSize={isPortrait ? "0.53em" : "0.85em"}
												>
													Contribute to Poi’s Bounty
												</CardFinalMessage>
											)}
										*/}
									</LoyalBox>
								</LoyalBoxWrap>
							)}
							<Button
								variant="contained"
								color="success"
								size="large"
								disabled={!isPreviousTierCompleted()}
								onClick={onClickBuy}
								sx={{
									position: "relative",
									fontSize: "1em",
									width: "14em",
									height: "15.7%",
									marginTop: "1em"
								}}
							>
								{offer?.price} USD
								{!isPreviousTierCompleted() && <LockIcon src={chain} />}
							</Button>
						</>
					)}
				</>
			)}
		</Container>
	);
};
